import { Trans } from '@lingui/react/macro';

import { ActivityOfType } from '@/components/activities/Activity';
import {
  BaseActivity,
  BaseActivityArticleName,
  BaseActivityText,
} from '@/components/activities/BaseActivity/BaseActivity';
import IconRepairValidation from '@/icons/RepairValidation.svg';

export const ArticleProcessingCompletedActivity = ({
  activity,
  displayArticleName,
}: {
  activity: ActivityOfType<'article_processing_completed'>;
  displayArticleName: boolean;
}) => {
  const trackingNumber = activity.data.trackingNumber;
  const creatorName = activity.creator?.name;

  const articleName = (
    <BaseActivityArticleName activity={activity} displayArticleName={displayArticleName} />
  );

  return (
    <BaseActivity
      createdAt={activity.createdAt}
      type="primary"
      icon={<IconRepairValidation />}
      message={
        <BaseActivityText>
          {activity.data.trackingNumber ? (
            <Trans id="activities.article_processing_completed.message.tracking_number">
              <strong>{creatorName}</strong> confirmed reception of the item {articleName} with
              tracking number {trackingNumber} following workshop processing
            </Trans>
          ) : (
            <Trans id="activities.article_processing_completed.message">
              <strong>{creatorName}</strong> confirmed reception of the item {articleName} following
              workshop processing
            </Trans>
          )}
        </BaseActivityText>
      }
    />
  );
};
